import React, { useState, useEffect, useContext, useMemo, useRef, useLayoutEffect} from 'react';

import AppContext from '../hooks/AppContext'
import SearchParamContext from '../hooks/SearchParamContext'

import MainPage from '../_template/MainPage'
import ListaZonas from '../components/ListaZonas'

const Secoes = (props) => {
 
  const { mock, instanciaInfo, setLoading, ocultaLidas, ocultaNLidas, ocultaZonasConcluidas, 
     acompanhamentoSecoes, locaisVotacao, localidades, zonasEleitorais,
     localidadeSelecionada, zonaESelecionada, localVSelecionado, setLocalidadeSelecionadaId} = useContext(AppContext);
  const {paramEle, paramLocal, paramCargo, paramZe, paramLovalVota} = useContext(SearchParamContext); 
  
  const [searchSessao, setSearchSessao] = useState(null); 
  
  const searchField = useRef()

  //Seleciona Uf como localidade caso nata tenho sido selecionado  
  /*useEffect(()=>{
    if(!paramLocal && !paramZe && !paramLovalVota){      
      setLocalidadeSelecionadaId(instanciaInfo?.uf?.sgUe);
    }
  },[])*/

  //Desativa o loading ao carregar os dados básicos da tela
  useEffect(()=>{        
    if(localidades?.length>0 && zonasEleitorais?.length>0 && instanciaInfo && instanciaInfo?.onLine!=false){
      setLoading(false)  
    }
  },[zonasEleitorais, localidades, instanciaInfo, searchSessao])

  //limpa campos de pesquisa quando ocultado
  useEffect(() => {   
    if(!((localidadeSelecionada && !localidadeSelecionada?.isUf) || zonaESelecionada)){    
      limpaFiltro()
    }
  }, [localidadeSelecionada,zonaESelecionada]);
  

  //Processa filtro de acompanhamento de Secoes
  const acompanhamentoSecoesFiltradas = useMemo(() => {
  
    //previne processamento desnecessários quando o objeto de origem não foi carregado
    if(!acompanhamentoSecoes){              
      return acompanhamentoSecoes
    }

    //Retorna undef se não tem nenhum campo selecionado
    if(!localidadeSelecionada && !zonaESelecionada && !localVSelecionado){
      return undefined
    }

    //Objeto padrão para carga de dados
    let acompanhamentoSecoesProcessado = {
      "dataHora" : acompanhamentoSecoes?.dataHora || undefined,
      "secoesLidas": 0,
      "totalSecoes": 0,
      "zonas": []
    }
    
    //Processa acompanhamentoSecoes com base nos filtros e configurações
    acompanhamentoSecoes?.zonas?.forEach( zona =>{       
      
      //oculta concluidas quando configurado
      if(!ocultaZonasConcluidas || zona?.secoesLidas?.length != zona?.totalSecoes){
        
        let zonaAbrangeLocalidadeSelecionada = zona?.localidades?.some(localidade => Number(localidade?.sgUe) == Number(localidadeSelecionada?.sgUe))         
        //verifica se zona deve ser exibida com base nos filtros de seleção
        if( (!localidadeSelecionada || zonaAbrangeLocalidadeSelecionada || localidadeSelecionada?.isUf || zonaESelecionada) &&         
            (!zonaESelecionada || zona?.nrZona == zonaESelecionada?.nrZona) && (!localVSelecionado || zona?.nrZona == localVSelecionado?.nrZona)){

            //clona dados da zona
            let zonaProcessada = Object.assign({}, zona);            

            //secoes da localidade selecionada que pertencem a zona
            let secoesLocalidadeZona = localidadeSelecionada?.secoes?.filter(localsec => localsec?.nrZona==zona?.nrZona)            
            
            //filtra os dados com base na localidades filtrada
            if(localidadeSelecionada && zonaAbrangeLocalidadeSelecionada && !localVSelecionado){
              zonaProcessada.localidades = [localidadeSelecionada]
            }
            //filtra os dados com base no local de votacao filtrado
            if(localVSelecionado){
              zonaProcessada.localidades = [localVSelecionado?.nmUeMun]
              zonaProcessada.localVotacao = localVSelecionado?.nmLocal
            }

            //filtra secoes lidas com base nos filtros de seleção
            zonaProcessada.secoesLidas = zonaProcessada?.secoesLidas?.filter( secao => {
              let localidadeSelecionadaContemSecao = secoesLocalidadeZona?.some(localsec => localsec.nrSecao==secao)                                
              return (
                (!localidadeSelecionada || localidadeSelecionadaContemSecao || localidadeSelecionada?.isUf) &&
                (!localVSelecionado || localVSelecionado?.secoes?.includes(secao))
              )
            })

            //filtra secoes não lidas com base nos filtros de seleção
            zonaProcessada.secoeNaosLidas = zonaProcessada?.secoesNaoLidas?.filter( secao => {
              let localidadeSelecionadaContemSecao = secoesLocalidadeZona?.some(localsec => (localsec.nrSecao==secao))                
              return( 
                (!localidadeSelecionada || localidadeSelecionadaContemSecao || localidadeSelecionada?.isUf) &&
                (!localVSelecionado || !zona?.secoesLidas.includes(secao))
              )
            })
            //calcula o numero de seções lidas e total de secoes para a zona            
            zonaProcessada.totalSecoes = zonaProcessada?.secoesLidas?.length + zonaProcessada?.secoesNaoLidas?.length                                              
            
            //calcula o numero de seções lidas e o total para o grupo de dados
            acompanhamentoSecoesProcessado.secoesLidas += zonaProcessada?.secoesLidas?.length
            acompanhamentoSecoesProcessado.totalSecoes += zonaProcessada?.totalSecoes         

            acompanhamentoSecoesProcessado.zonas?.push(zonaProcessada)
        }
      }       
    })

    if(acompanhamentoSecoesProcessado?.zonas?.length>0){
      return acompanhamentoSecoesProcessado;    
    }
    return undefined

  },[acompanhamentoSecoes, localidadeSelecionada, zonaESelecionada, localVSelecionado, ocultaZonasConcluidas]);

  const limpaFiltro = () => {          
    setSearchSessao(() => "")
    if(searchField.current){  
      searchField.current.value=""        
    }
  }

  const iniciaBusca = () =>{       
    if(searchField?.current?.value?.length >0){            
      setSearchSessao(searchField?.current?.value?.replace(/[^\d.-]/g, ' ').split(" "))
    }
  }

  const handleKey =(e) =>{
    if (e.key === 'Enter') {
      iniciaBusca()
    }
  }

  return (      
    <MainPage titulo={"Seções"}
      renderFiltro filtroZE filtroLocalDeVotacao 
      renderBusca={((localidadeSelecionada && !localidadeSelecionada?.isUf) || zonaESelecionada)} 
      searchField={searchField}
      handleKey={handleKey} iniciaBusca={iniciaBusca} limpaFiltro={limpaFiltro}
      acompanhamentoSecoes={acompanhamentoSecoesFiltradas} >

      <ListaZonas sessoesAgrupadas={acompanhamentoSecoesFiltradas} ocultaLidas={ocultaLidas} ocultaNLidas={ocultaNLidas} search={searchSessao}/>
      
    </MainPage>
  );
}


export default Secoes;
